import React from "react";
import {
  convertMoneyForDisplay,
  getMoneyCurrency,
  getMoneyFractionDigits,
  moneyToMajor,
} from "../domain/money";

export const formatMoney = (
  value,
  {
    currency = "KWD",
    language = "english",
    decimals = null,
    displayCurrency = null,
    forceBaseNumeric = false,
  } = {},
) => {
  const displayValue = convertMoneyForDisplay(value, displayCurrency, {
    forceBaseNumeric,
  });
  const major = moneyToMajor(displayValue);
  if (major === null) return "—";
  const serverCurrency = getMoneyCurrency(displayValue, currency) || "KWD";
  const serverDecimals = getMoneyFractionDigits(displayValue, decimals);
  const locale = language === "arabic" ? "ar" : "en";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: serverCurrency,
      ...(Number.isFinite(Number(serverDecimals))
        ? {
            minimumFractionDigits: Number(serverDecimals),
            maximumFractionDigits: Number(serverDecimals),
          }
        : {}),
    }).format(major);
  } catch (error) {
    return `${major.toFixed(Number.isFinite(Number(serverDecimals)) ? Number(serverDecimals) : 2)} ${serverCurrency || ""}`.trim();
  }
};

const Money = ({
  value,
  currency,
  language,
  decimals,
  displayCurrency,
  forceBaseNumeric,
  ...props
}) => (
  <span {...props}>
    {formatMoney(value, {
      currency,
      language,
      decimals,
      displayCurrency,
      forceBaseNumeric,
    })}
  </span>
);

export default Money;
